import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let Dropdown = class Dropdown extends Vue {
    render(h) {
        const that = this;
        return h("a-input", { props: {
                disabled: true,
                placeholder: that.$t('cloudpivot.form.dataitem.SelectPlaceholder').toString(),
            } }, [
            h("i", {
                props: {
                    type: "user"
                },
                slot: 'suffix',
                'class': [
                    'aufontAll',
                    'h-icon-all-down-o'
                ]
            })
        ]);
    }
};
tslib_1.__decorate([
    Prop()
], Dropdown.prototype, "control", void 0);
Dropdown = tslib_1.__decorate([
    Component({ name: 'Dropdown' })
], Dropdown);
export default Dropdown;
